import { useLocation, useNavigate } from 'react-router';
import { ChangePasswordForm, PasswordTips } from './components';
import { useState } from 'react';
import { ChangePasswordError } from 'user/models/errors/ChangePasswordError';
import { useAuthService } from 'auth/services/useAuthService';
import { useSecurity } from 'auth/hooks/useSecurity';
import { LoginPhase } from 'navigation/models/login-phase';
import { Col, Container, Row } from 'react-bootstrap';
import { useRootLoadingSpinner } from 'shared/spinner';
import { useNotifications } from 'shared/notifications';
import { PageTitle } from 'shared/components/Fonts';
import { Alert } from '@orbita-ui/core';
import { FetchDataError } from 'shared/http';
import { HOME_PATH } from 'navigation/routes';
import { Card } from 'shared/components';
import { Button } from '@orbita-ui/core';

export function ChangePasswordPage() {
  const { saveLoginPhase, loginPhase } = useSecurity();
  const authService = useAuthService();
  const [changePasswordError, setChangePasswordError] =
    useState<ChangePasswordError>(null);
  const { setRootLoadingSpinnerStatus } = useRootLoadingSpinner();
  const [wasPasswordChanged, setWasPasswordChanged] = useState(false); // ✅ Nuevo estado
  const navigate = useNavigate();

  const { state } = useLocation();
  const { addNotification } = useNotifications();

  const goLoginOrMenuHandler = () => {
    navigate(HOME_PATH);
  };

  const handleSubmit = ({ oldPassword, newPassword, confirmPassword }) => {
    setChangePasswordError(null);
    setRootLoadingSpinnerStatus(true);
    authService
      .doChangePassword({ oldPassword, newPassword, confirmPassword })
      .then(() => {
        addNotification('La clave ha sido actualizada correctamente', 'success');
        setWasPasswordChanged(true);

        if (!state?.fromMenu) {
          saveLoginPhase(LoginPhase.LOGGED_IN);
          navigate(HOME_PATH);
        }
      })
      .catch((e: FetchDataError) => {
        setChangePasswordError(e.apiError.message as ChangePasswordError);
      })
      .finally(() => setRootLoadingSpinnerStatus(false));
  };

  return (
    <Container>
      {state?.fromMenu && (
        <Row className="mb-3">
          <PageTitle>Cambiar contraseña</PageTitle>
        </Row>
      )}

      {loginPhase === LoginPhase.EXPIRED_PASSWORD && (
        <Row className="mb-3">
          <Col>
            <Alert
              variant="error"
              subtitle="Su clave expiró. Para poder continuar debe cambiarla"
              fullWidth
            />
          </Col>
        </Row>
      )}
      {!wasPasswordChanged &&
        <Row className="mb-3">
          <Col>
            <PasswordTips />
          </Col>
        </Row>
      }
      <Row>
        <Col>
          {wasPasswordChanged ? (
            <Card variant="info">
              <Row className="mt-1 mb-3">
                <Col>Su constraseña ha sido cambiada con exito</Col>
              </Row>
              <Row>
                <Col className="mb-2 text-end">
                  <Button onClick={() => goLoginOrMenuHandler()}>Aceptar</Button>
                </Col>
              </Row>
            </Card>
          ) : (
            <ChangePasswordForm
              onSubmit={handleSubmit}
              changePasswordError={changePasswordError}
            />
          )}
        </Col>
      </Row>
    </Container>
  );
}
